<template>
    <div style="background-color: #f2f6ff;width:100%;height: 100%">
        <!--公共视频页面-->
        <common-video v-show="!loading" @loadingFinally="loadFinally" :loading="loading"  :commonAlbumId="commonAlbumId"></common-video>
        <loading  :show="loading"></loading>
    </div>
</template>
<script>
    import {videoPackageDetails} from "../../config";
    import {EventBus} from "../../assets/static/global/event-bus";
    export default {
        name: "teacherSourceVideo",
        data(){
            return{
                loading:false,
                commonAlbumId:'',
                //获取整个查出的数据内容
                getAllPackageContent:{}
            }
        },
        mounted() {
            this.lookVideoAlumbId();
        },
        methods:{
            //加载完成之后将loading设置为true
            loadFinally(){
                console.log('触发了');
                this.loading=false;
            },
            //获取视频专辑id根据专辑id查出内容
            async lookVideoAlumbId(){
                this.loading=true;
                this.commonAlbumId=this.$route.query.albumId;
                this.type=this.$route.query.type;
                let videoId='';
                let hwItemId='';
                if(this.$route.query.itemId){
                    hwItemId=this.$route.query.itemId;
                }
                if(this.$route.query.videoId!==undefined){
                    videoId=this.$route.query.videoId;
                }

                EventBus.$emit('commonAlbumId',{commonAlbumId:this.commonAlbumId,type:this.type,videoId:videoId,itemId:hwItemId});
            }
        }
    }
</script>

<style scoped>

</style>
